var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress)?_c('van-progress',{attrs:{"stroke-width":"4","show-pivot":false,"percentage":_vm.progress,"color":"#996eff"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }